export const EinsteinIcon = ({ className = "", strokeWidth = 1.5 }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="13.5" r="5.5" />
    <path d="M6.8 10 5 8" />
    <path d="M8.4 8.4 7.4 6" />
    <path d="M10.4 7.6 10 5.2" />
    <path d="M12.2 7.4 12.3 5" />
    <path d="M14 7.6 14.6 5.3" />
    <path d="M15.7 8.4 16.9 6.2" />
    <path d="M17.2 10 19 8.2" />
    <path d="M10 15.6q2 1.3 4 0" />
  </svg>
);
